import * as React from 'react'

import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { Config } from '@chegg-wt/core/config'
import { NextPage } from 'next'
import LayoutsTermsAndConditions from '@chegg-wt/core/components/Layouts/TermsAndconditions'
import {
  AUTO_RENEWAL_TEXT_EB_CM,
  EXPERT_CHECK,
  SUBSCRIPTION_TEXT,
  TERMS_AND_CONDITIONS,
} from '@chegg-wt/core/components/Layouts/TermsAndconditions/constants'
import { CancellationText } from '@chegg-wt/core/components/Layouts/TermsAndconditions/utils'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { SUPPORT_LINK } from '../copy/termsAndConditions'

const TermsAndConditions: NextPage<{}> = () => {
  const legalList: React.ReactNode[] = []
  legalList.push(
    SUBSCRIPTION_TEXT,
    AUTO_RENEWAL_TEXT_EB_CM,
    EXPERT_CHECK,
    CancellationText(SUPPORT_LINK)
  )
  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle title={`Terms and Conditions | ${Config.siteName}`} />
      <LayoutsTermsAndConditions title={TERMS_AND_CONDITIONS} legalList={legalList} />
    </>
  )
}

export default TermsAndConditions
